import React from 'react'
import { config } from 'config'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Helmet from 'react-helmet'
import { Container } from 'react-responsive-grid'
import { rhythm } from '../utils/typography'
import ThreejsBackdrop from 'components/ThreejsBackdrop'
import PortfolioSection from 'components/PortfolioSection'
import styles from './about.module.scss'
import profilePic from 'components/profile-pic.jpg'
import works from 'data/works'
import workCategories from 'data/work-categories'
import Scroll from 'react-scroll'

export default class Index extends React.Component {
  
  render () {
    let ScrollElement = Scroll.Element;
    let ScrollLink = Scroll.Link;

    return (
      <div>
        <Helmet
          title={config.siteTitle}
          meta={[
            {"name": "description", "content": "Sample"},
            {"name": "keywords", "content": "sample, something"},
          ]}
        />
        <div className={styles.bioContainer}>
          <Container
              style={{
                maxWidth: 1170,
              }}
            >
            <div className="section">
              <div className="section-header">
                <h2>MUSIC</h2>
              </div>
              <p> 
                I do regular cover of musical saw.
              </p>
            </div>
          </Container>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./music.js
 **/